import { createActionCreator } from "deox";
import {
  IActiveSubscriptionModel,
  IIntervalGroupModel,
} from "../../../types/types";

export const pricingTableLoading = createActionCreator("pricingTableLoading");
export const pricingTableLoadingError = createActionCreator(
  "pricingTableLoadingError"
);

export const pricingTableLoaded = createActionCreator(
  "pricingTableLoaded",
  (resolve) => (payload: IIntervalGroupModel[]) => resolve(payload)
);

export const activeSubscriptionLoading = createActionCreator(
  "activeSubscriptionLoading"
);
export const activeSubscriptionLoadingError = createActionCreator(
  "activeSubscriptionLoadingError"
);
export const activeSubscriptionLoaded = createActionCreator(
  "activeSubscriptionLoaded",
  (resolve) => (payload: IActiveSubscriptionModel) => resolve(payload)
);
